import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "checkout" }
const _hoisted_2 = { class: "checkout-block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Способ получения", -1)
const _hoisted_4 = { class: "checkout__delivery-type" }
const _hoisted_5 = { class: "checkout__delivery-type-address" }
const _hoisted_6 = { class: "checkout-block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Даты доставки", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "checkout-block" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Личные данные", -1)
const _hoisted_11 = { class: "form-element" }
const _hoisted_12 = { class: "error-msg" }
const _hoisted_13 = { class: "form-element" }
const _hoisted_14 = { class: "error-msg" }
const _hoisted_15 = { class: "form-element" }
const _hoisted_16 = { class: "error-msg" }
const _hoisted_17 = { class: "checkout-block" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Данные для доставки", -1)
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "form-element" }
const _hoisted_21 = { class: "error-msg" }
const _hoisted_22 = { class: "form-element" }
const _hoisted_23 = { class: "error-msg" }
const _hoisted_24 = { class: "form-element" }
const _hoisted_25 = { class: "error-msg" }
const _hoisted_26 = { class: "form-element" }
const _hoisted_27 = { class: "error-msg" }
const _hoisted_28 = { class: "checkout-block" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Способ оплаты", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "card-list__item-card-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "13",
    height: "14",
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M11.9999 7.58216H8.66658V10.4988C8.66658 10.6535 8.59635 10.8019 8.47132 10.9113C8.3463 11.0207 8.17673 11.0822 7.99992 11.0822C7.82311 11.0822 7.65354 11.0207 7.52851 10.9113C7.40349 10.8019 7.33325 10.6535 7.33325 10.4988V7.58216H3.99992C3.82311 7.58216 3.65354 7.52071 3.52851 7.41131C3.40349 7.30191 3.33325 7.15354 3.33325 6.99883C3.33325 6.84412 3.40349 6.69575 3.52851 6.58635C3.65354 6.47695 3.82311 6.4155 3.99992 6.4155H7.33325V3.49883C7.33325 3.34412 7.40349 3.19575 7.52851 3.08635C7.65354 2.97695 7.82311 2.9155 7.99992 2.9155C8.17673 2.9155 8.3463 2.97695 8.47132 3.08635C8.59635 3.19575 8.66658 3.34412 8.66658 3.49883V6.4155H11.9999C12.1767 6.4155 12.3463 6.47695 12.4713 6.58635C12.5963 6.69575 12.6666 6.84412 12.6666 6.99883C12.6666 7.15354 12.5963 7.30191 12.4713 7.41131C12.3463 7.52071 12.1767 7.58216 11.9999 7.58216Z",
      fill: "white"
    })
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "card-list__item-text" }, "Добавить", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "card-list__item-card-number" }
const _hoisted_35 = { class: "card-list__item-card-icon" }
const _hoisted_36 = {
  key: 0,
  width: "18",
  height: "12",
  viewBox: "0 0 18 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_911_152005)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.17857 1.72989C6.92049 2.74875 6.11867 4.29037 6.11867 6.01598C6.11867 7.74159 6.92049 9.28321 8.17857 10.3021C7.30849 10.8742 6.29205 11.1775 5.25385 11.1748C2.35211 11.1748 0.000244141 8.86535 0.000244141 6.01598C0.000244141 3.16661 2.35211 0.857196 5.25385 0.857196C6.33657 0.857196 7.34269 1.17876 8.17857 1.72989ZM8.84591 10.3021C10.104 9.28321 10.9058 7.74159 10.9058 6.01598C10.9058 4.29037 10.104 2.74875 8.84591 1.72989C9.71599 1.15775 10.7324 0.854461 11.7706 0.857196C14.6724 0.857196 17.0242 3.16661 17.0242 6.01598C17.0242 8.86535 14.6724 11.1748 11.7706 11.1748C10.7324 11.1775 9.71599 10.8742 8.84591 10.3021ZM8.51224 1.96891C9.72775 2.91469 10.5074 4.37635 10.5074 6.01598C10.5074 7.65647 9.72775 9.11813 8.51224 10.063C7.29672 9.11727 6.51703 7.65561 6.51703 6.01598C6.51703 4.37549 7.29672 2.91383 8.51224 1.96891Z",
    fill: "white"
  })
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_911_152005" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "17.024",
      height: "10.3176",
      fill: "white",
      transform: "translate(0 0.856934)"
    })
  ])
], -1)
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = { class: "checkout-block__card-container" }
const _hoisted_41 = { class: "checkout-block__card-change-list" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "card-list__item-left" }
const _hoisted_44 = { class: "card-list__item-card-icon" }
const _hoisted_45 = {
  key: 0,
  width: "18",
  height: "12",
  viewBox: "0 0 18 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_911_152005)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.17857 1.72989C6.92049 2.74875 6.11867 4.29037 6.11867 6.01598C6.11867 7.74159 6.92049 9.28321 8.17857 10.3021C7.30849 10.8742 6.29205 11.1775 5.25385 11.1748C2.35211 11.1748 0.000244141 8.86535 0.000244141 6.01598C0.000244141 3.16661 2.35211 0.857196 5.25385 0.857196C6.33657 0.857196 7.34269 1.17876 8.17857 1.72989ZM8.84591 10.3021C10.104 9.28321 10.9058 7.74159 10.9058 6.01598C10.9058 4.29037 10.104 2.74875 8.84591 1.72989C9.71599 1.15775 10.7324 0.854461 11.7706 0.857196C14.6724 0.857196 17.0242 3.16661 17.0242 6.01598C17.0242 8.86535 14.6724 11.1748 11.7706 11.1748C10.7324 11.1775 9.71599 10.8742 8.84591 10.3021ZM8.51224 1.96891C9.72775 2.91469 10.5074 4.37635 10.5074 6.01598C10.5074 7.65647 9.72775 9.11813 8.51224 10.063C7.29672 9.11727 6.51703 7.65561 6.51703 6.01598C6.51703 4.37549 7.29672 2.91383 8.51224 1.96891Z",
    fill: "white"
  })
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_911_152005" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "17.024",
      height: "10.3176",
      fill: "white",
      transform: "translate(0 0.856934)"
    })
  ])
], -1)
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "10",
  viewBox: "0 0 12 10",
  fill: "none"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.841399 4.75123C-0.280467 5.95256 -0.280467 7.89809 0.841399 9.09942C1.8342 10.1625 3.39886 10.3008 4.54058 9.42686L4.57235 9.40348C4.85828 9.18447 4.9238 8.75922 4.71929 8.45517C4.51477 8.15111 4.11765 8.07882 3.8337 8.29782L3.80194 8.32121C3.16456 8.80812 2.29288 8.73158 1.74088 8.13835C1.11541 7.46858 1.11541 6.38419 1.74088 5.71442L3.96873 3.32451C4.59419 2.65474 5.60685 2.65474 6.23232 3.32451C6.7863 3.91774 6.85778 4.85116 6.40308 5.53156L6.38124 5.56558C6.17672 5.87177 6.24423 6.29702 6.52817 6.51389C6.81211 6.73077 7.21122 6.66061 7.41375 6.35655L7.43559 6.32253C8.25366 5.10206 8.1246 3.42657 7.13179 2.36344C6.00993 1.16211 4.1931 1.16211 3.07123 2.36344L0.841399 4.75123ZM11.1586 5.24877C12.2805 4.04744 12.2805 2.10191 11.1586 0.900579C10.1658 -0.162548 8.60114 -0.300755 7.45942 0.573136L7.42765 0.596525C7.14172 0.815529 7.0762 1.24078 7.28071 1.54484C7.48523 1.84889 7.88235 1.92118 8.16629 1.70218L8.19806 1.67879C8.83544 1.19188 9.70712 1.26842 10.2591 1.86165C10.8846 2.53354 10.8846 3.61793 10.2591 4.2877L8.03127 6.67549C7.40581 7.34526 6.39315 7.34526 5.76768 6.67549C5.2137 6.08226 5.14222 5.14884 5.59692 4.46631L5.61876 4.43229C5.82328 4.12611 5.75577 3.70086 5.47183 3.48398C5.18789 3.2671 4.78878 3.33727 4.58625 3.64132L4.56441 3.67534C3.74634 4.89794 3.8754 6.57343 4.86821 7.63656C5.99007 8.83789 7.8069 8.83789 8.92877 7.63656L11.1586 5.24877Z",
  fill: "white"
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "card-list__item-card-number" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__card-add-text" }, "Добавить карту", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "26",
  viewBox: "0 0 25 26",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.1429 13.8571H12.8571V18.1429C12.8571 18.3702 12.7668 18.5882 12.6061 18.7489C12.4453 18.9097 12.2273 19 12 19C11.7727 19 11.5547 18.9097 11.3939 18.7489C11.2332 18.5882 11.1429 18.3702 11.1429 18.1429V13.8571H6.85714C6.62981 13.8571 6.4118 13.7668 6.25105 13.6061C6.09031 13.4453 6 13.2273 6 13C6 12.7727 6.09031 12.5547 6.25105 12.3939C6.4118 12.2332 6.62981 12.1429 6.85714 12.1429H11.1429V7.85714C11.1429 7.62981 11.2332 7.4118 11.3939 7.25105C11.5547 7.09031 11.7727 7 12 7C12.2273 7 12.4453 7.09031 12.6061 7.25105C12.7668 7.4118 12.8571 7.62981 12.8571 7.85714V12.1429H17.1429C17.3702 12.1429 17.5882 12.2332 17.7489 12.3939C17.9097 12.5547 18 12.7727 18 13C18 13.2273 17.9097 13.4453 17.7489 13.6061C17.5882 13.7668 17.3702 13.8571 17.1429 13.8571Z",
    fill: "white"
  })
], -1)
const _hoisted_55 = [
  _hoisted_53,
  _hoisted_54
]
const _hoisted_56 = { class: "error-msg" }
const _hoisted_57 = {
  key: 1,
  class: "pay-drawer__cards-body"
}
const _hoisted_58 = { class: "pay-drawer__card-block" }
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<label for=\"pay-drawer-card-1\" class=\"pay-drawer__card\"><div class=\"pay-drawer__card-selected\"><i class=\"pay-drawer__card-selected-img\"></i></div><div class=\"pay-drawer__card-header\"><div class=\"pay-drawer__card-logo\"><i class=\"pay-drawer__card-img\"></i></div><div class=\"pay-drawer__card-title\">Ситибанк</div></div><div class=\"pay-drawer__card-bottom\"><div class=\"pay-drawer__card-number\">•••• 4211</div><div class=\"pay-drawer__card-date\">12/21</div></div></label><div class=\"pay-drawer__card-mastercard\"><i class=\"pay-drawer__card-mastercard-img\"></i></div>", 2)
const _hoisted_61 = { class: "pay-drawer__card-block" }
const _hoisted_62 = /*#__PURE__*/_createStaticVNode("<label for=\"pay-drawer-card-2\" class=\"pay-drawer__card\"><div class=\"pay-drawer__card-selected\"><i class=\"pay-drawer__card-selected-img\"></i></div><div class=\"pay-drawer__card-header\"><div class=\"pay-drawer__card-logo\"><i class=\"pay-drawer__card-tinkoff-img\"></i></div><div class=\"pay-drawer__card-title\">Тинькофф</div></div><div class=\"pay-drawer__card-bottom\"><div class=\"pay-drawer__card-number\">•••• 4211</div><div class=\"pay-drawer__card-date\">12/21</div></div><div class=\"pay-drawer__card-mastercard\"><i class=\"pay-drawer__card-mastercard-img\"></i></div></label>", 1)
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<div class=\"pay-drawer__card-add\"><div class=\"pay-drawer__card-add-body\"><div class=\"pay-drawer__card-add-svg-container\"><i class=\"pay-drawer__card-add-svg\"></i></div><span class=\"pay-drawer__card-add-title\">Добавить карту</span></div></div>", 1)
const _hoisted_64 = { class: "checkout-block" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Введите промокд", -1)
const _hoisted_66 = { class: "form-element" }
const _hoisted_67 = { class: "checkout-block__flex" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = {
  key: 0,
  class: "loader",
  style: {"margin-right":"10px"}
}
const _hoisted_70 = {
  key: 0,
  class: "input-errors"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "error-msg" }, "Промокод не верный", -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = {
  key: 1,
  class: "input-success"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "error-msg" }, "Промокод верный", -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = { class: "checkout-block" }
const _hoisted_77 = {
  key: 0,
  class: "checkout-block__group"
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Товары", -1)
const _hoisted_79 = {
  key: 1,
  class: "checkout-block__group"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Доставка", -1)
const _hoisted_81 = {
  key: 2,
  class: "checkout-block__group"
}
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "checkout-block__title" }, "Скидка", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "separate" }, null, -1)
const _hoisted_84 = { class: "checkout-block__group" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("h3", null, "Итого", -1)
const _hoisted_86 = ["disabled"]
const _hoisted_87 = {
  key: 0,
  class: "loader",
  style: {"margin-right":"10px"}
}
const _hoisted_88 = {
  class: "basket__consent",
  style: {"margin-top":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ADeliveryDate = _resolveComponent("ADeliveryDate")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "btn-group",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalChangeDelivery()))
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn", { btn__gray: _ctx.deliveryType != 'delivery' }])
          }, " Доставка ", 2),
          _createElementVNode("button", {
            class: _normalizeClass(["btn", { btn__gray: _ctx.deliveryType != 'pickup' }])
          }, " Самовывоз ", 2)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.deliveryType == "delivery"
              ? _ctx.deliveryPoint?.address
              : _ctx.pickupPoint?.address), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipments, (shipment, idx) => {
        return (_openBlock(), _createBlock(_component_ADeliveryDate, {
          class: "form-element",
          modelValue: _ctx.model.delivery[idx],
          "onUpdate:modelValue": ($event: any) => ((_ctx.model.delivery[idx]) = $event),
          source: shipment,
          key: idx
        }, null, 8, ["modelValue", "onUpdate:modelValue", "source"]))
      }), 128)),
      (_ctx.isShowBtnOneDay)
        ? (_openBlock(), _createElementBlock("label", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.oneDay) = $event)),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendRequest()))
            }, null, 544), [
              [_vModelCheckbox, _ctx.model.oneDay]
            ]),
            _createTextVNode(" Доставить всё в один день ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.name) = $event)),
          class: _normalizeClass({ 'has-error': _ctx.v$.model.name.$error }),
          type: "text",
          placeholder: "ФИО"
        }, null, 2), [
          [_vModelText, _ctx.model.name]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.model.name.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.email) = $event)),
          class: _normalizeClass({ 'has-error': _ctx.v$.model.email.$error }),
          type: "text",
          placeholder: "E-mail"
        }, null, 2), [
          [_vModelText, _ctx.model.email]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.model.email.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.phone) = $event)),
          class: _normalizeClass({ 'has-error': _ctx.v$.model.phone.$error }),
          type: "text",
          placeholder: "Телефон",
          "data-maska": "+7 (###) ##-##-###"
        }, null, 2), [
          [_vModelText, _ctx.model.phone],
          [_directive_maska]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.model.phone.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.entrance) = $event)),
            class: _normalizeClass({ 'has-error': _ctx.v$.model.entrance.$error }),
            type: "text",
            placeholder: "Подъезд"
          }, null, 2), [
            [_vModelText, _ctx.model.entrance]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.model.entrance.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.floor) = $event)),
            class: _normalizeClass({ 'has-error': _ctx.v$.model.floor.$error }),
            type: "text",
            placeholder: "Этаж"
          }, null, 2), [
            [_vModelText, _ctx.model.floor]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.model.floor.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.flat) = $event)),
            class: _normalizeClass({ 'has-error': _ctx.v$.model.flat.$error }),
            type: "text",
            placeholder: "Квартира"
          }, null, 2), [
            [_vModelText, _ctx.model.flat]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.model.flat.$errors, (error) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "input-errors",
              key: error.$uid
            }, [
              _createElementVNode("div", _hoisted_25, _toDisplayString(error.$message), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.comment) = $event)),
          class: _normalizeClass({ 'has-error': _ctx.v$.model.comment.$error }),
          type: "text",
          placeholder: "Комментарий"
        }, "\n        ", 2), [
          [_vModelText, _ctx.model.comment]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.model.comment.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "input-errors",
            key: error.$uid
          }, [
            _createElementVNode("div", _hoisted_27, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ])
    ], 512), [
      [_vShow, _ctx.deliveryType == 'delivery']
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      false
        ? (_openBlock(), _createBlock(_component_swiper, {
            key: 0,
            "slides-per-view": 3,
            "space-between": 10
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "card-list__item card-list__item-dark",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addPayCard(() => {})))
                  }, _hoisted_32)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card, key) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, { key: key }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.changeCard(card)),
                      class: _normalizeClass(["card-list__item", { 'card-list__item_selected': _ctx.model.card == card }])
                    }, [
                      _createElementVNode("div", _hoisted_34, _toDisplayString(card.displayLabel.replaceAll("X", "*")), 1),
                      _createElementVNode("div", _hoisted_35, [
                        (card.cardType)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_36, _hoisted_39))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_33)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("ul", _hoisted_41, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card, key) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "checkout-block__card-change-item",
              key: key
            }, [
              _createElementVNode("div", {
                onClick: ($event: any) => (_ctx.changeCard(card)),
                class: _normalizeClass(["card-list__item", { 'card-list__item_selected': _ctx.model.card == card }])
              }, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    (card.cardType)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_45, _hoisted_48))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_49, _hoisted_51))
                  ]),
                  _createElementVNode("div", _hoisted_52, _toDisplayString(card.displayLabel.replaceAll("X", "*")), 1)
                ])
              ], 10, _hoisted_42)
            ]))
          }), 128))
        ]),
        _createElementVNode("button", {
          class: "checkout-block__card-add",
          type: "button",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addPayCard(() => {})))
        }, _hoisted_55)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.model.card.$errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "input-errors",
          key: error.$uid
        }, [
          _createElementVNode("div", _hoisted_56, _toDisplayString(error.$message), 1)
        ]))
      }), 128)),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("input", {
                checked: "",
                id: "pay-drawer-card-1",
                name: "pay-drawer-card-radio",
                type: "radio",
                value: "1",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.radioChangeCard($event.target)))
              }),
              _hoisted_59
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("input", {
                id: "pay-drawer-card-2",
                name: "pay-drawer-card-radio",
                type: "radio",
                value: "2",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.radioChangeCard($event.target)))
              }),
              _hoisted_62
            ]),
            _hoisted_63
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_64, [
      _hoisted_65,
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _withDirectives(_createElementVNode("input", {
            onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.checkPromo())),
            onFocus: _cache[15] || (_cache[15] = 
              () => {
                _ctx.promocodeApplied = null;
              }
            ),
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.promocode) = $event)),
            type: "text",
            placeholder: "Промокод"
          }, null, 544), [
            [_vModelText, _ctx.promocode]
          ]),
          _createElementVNode("button", {
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkPromo())),
            class: "btn",
            disabled: _ctx.loading
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_69))
              : _createCommentVNode("", true),
            _createTextVNode(" Применить ")
          ], 8, _hoisted_68)
        ]),
        (_ctx.promocodeApplied == false && _ctx.promocode !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_72))
          : _createCommentVNode("", true),
        (_ctx.promocodeApplied == true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      (_ctx.total.basePrice >= 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _hoisted_78,
            _createElementVNode("b", null, _toDisplayString(_ctx.priceFormat(_ctx.total.basePrice)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.total.deliveryPrice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("b", null, _toDisplayString(_ctx.priceFormat(_ctx.total.deliveryPrice)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.total.discountPrice > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
            _hoisted_82,
            _createElementVNode("b", null, _toDisplayString(_ctx.priceFormat(_ctx.total.discountPrice)), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_83,
      _createElementVNode("div", _hoisted_84, [
        _hoisted_85,
        _createElementVNode("b", null, _toDisplayString(_ctx.priceFormat(_ctx.total.price)), 1)
      ]),
      _createElementVNode("button", {
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submit())),
        class: "btn",
        style: {"width":"100%","margin-top":"20px"},
        disabled: _ctx.loading
      }, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_87))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.model.card ? "Оформить" : "Перейти к оплате"), 1)
      ], 8, _hoisted_86),
      _createElementVNode("div", _hoisted_88, [
        _createTextVNode(" Нажимая на кнопку вы соглашаетесь с "),
        _createElementVNode("span", {
          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.showPersonalData && _ctx.showPersonalData(...args))),
          class: "pay-drawer__consent--link basket__consent basket__consent--link"
        }, " условия обработки персональных данных ")
      ])
    ])
  ]))
}